/**
 * Shared @dnd-kit drag handle. Standardizes the glyph and styling
 * across drag-reorder consumers.
 *
 * Existing 4 callers (ToolDetailScreen.jsx, DisposalDetailPanel.jsx,
 * LifecycleDetailPanel.jsx, GridView/SortPanel.jsx) hand-roll the same
 * `<span className="?-drag-handle" {...attributes} {...listeners}>&#10495;</span>`
 * pattern with prefixed class names (td-, ddp-, ldp-, gv-sort-). This
 * component is the canonical extraction; the existing 4 are intentionally
 * left untouched per Phase 2A spec section 6.3 (no refactor in this session).
 *
 * Glyph: U+28FF (BRAILLE PATTERN DOTS-12345678, ⣿). Decimal HTML entity
 * &#10495;. Visual match to the existing callers.
 */

import React from 'react';
import './DragHandle.css';

export default function DragHandle({ attributes, listeners, ariaLabel = 'Reorder item' }) {
  return (
    <span
      className="drag-handle"
      role="button"
      aria-label={ariaLabel}
      {...attributes}
      {...listeners}
    >
      &#10495;
    </span>
  );
}
